import { newsApi } from './api';

export const ProfileService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getProfile: build.query({
            query: () => ({
                url: `me`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },

            }),
            providesTags: ['Profile'],
        }),
        editProfile: build.mutation({
            query: (form) => ({
                url: `me/update`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Profile'],
        }),
        changePassword: build.mutation({
            query: (form) => ({
                url: `me/change-password`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Profile'],
        }),
    }),
    overrideExisting: false,
})

export const { useGetProfileQuery, useEditProfileMutation, useChangePasswordMutation } = ProfileService